<template>
    <div v-loading="$parentInfo.dialog_InvoiceDetail.loading" class="printOrder-data" >
        <vue-scroll :ops="$ops">
            <div class="noprint" v-show="$parentInfo.dialog_InvoiceDetail.printOn">
                <el-button icon="el-icon-printer" v-print="'#print'"
                           size="small">打印合同
                </el-button>
                <div style="position: absolute;right: 140px;top: -8px;z-index: 1;">
                    <canvas id="msg"></canvas>
                </div>
            </div>
            <div :style="{'height':$parentInfo.dialog_InvoiceDetail.maxHeight-45+'px'}" id="print">
                <div v-if="$parentInfo.dialog_InvoiceDetail.invoiceDetail_val.type===1">
                    <div class="row printableArea"
                         v-if="$parentInfo.dialog_InvoiceDetail.showOn"
                         :class="{'ph':!$parentInfo.dialog_InvoiceDetail.printOn,'show':$parentInfo.dialog_InvoiceDetail.printOn}"
                         style=";position: relative;">
                        <div class='invoiceNumber'>
                            合同编号：{{$parentInfo.dialog_InvoiceDetail.invoiceDetail_val.id}}-{{$parentInfo.dialog_InvoiceDetail.invoiceDetail_val.version}}
                        </div>
                        <div >
                            <h3   class="title" >
                            墨帝教育服务协议书</h3>
                        </div>
                        <div >
                            <p><b>甲方（教 育 方）：应试君线上服务平台（上海墨帝教育科技有限服务公司）<br>
                                甲方地址：上海市青浦区盈港路499弄港隆广场6号 邮政编码：201700<br>
                                甲方联系方式：13764117924　微信号：modixuelaoshi　公众号：墨帝教育<br>
                            </b></p>
                            <p><b>乙方（受教育方）：学生姓名：
                                <span
                                        style="text-decoration: underline">　　{{$parentInfo.dialog_InvoiceDetail.invoiceDetail_val.student_name}}　</span>　　学校：<span
                                        style="text-decoration: underline">　{{$parentInfo.dialog_InvoiceDetail.invoiceDetail_val.student_school}}　
                                　</span>　　现新年级：<span style="text-decoration: underline">　{{$parentInfo.dialog_InvoiceDetail.invoiceDetail_val.student_grade}}　</span><br>
                                乙方 监 护 人：<span style="text-decoration: underline">　{{$parentInfo.dialog_InvoiceDetail.invoiceDetail_val.parent_name}}　 {{$parentInfo.dialog_InvoiceDetail.invoiceDetail_val.parent_identity}}　</span>　<br>
                                乙方 联系方式：<span
                                        style="text-decoration: underline">　{{$parentInfo.dialog_InvoiceDetail.invoiceDetail_val.student_phone}}　</span>　　家长联系方式：<span
                                        style="text-decoration: underline">　{{$parentInfo.dialog_InvoiceDetail.invoiceDetail_val.parent_phone}}　</span>　
                            </b></p>
                            <p>
                                为了使乙方的学习兴趣给予激发，学习习惯给予培养，学习方法给予改进，学习个性给予发扬，学习潜力给予发挥，应试能力给予加强，学习成绩给予提高，甲方和乙方监护人本着诚信、自愿、平等的原则，就委托辅导一事达成如下协议：</p>
                        </div>
                        <div >
                            <h3>第一条 费用及相关内容</h3>

                            <p>1.乙方向甲方交纳的费用包括：<br>
                                A.报名建档费、档案管理费、选派教员费、辅导方案制定费和网络服务费。<br>
                                B.平台服务费用（含辅导费）￥ <span
                                        style="text-decoration: underline">　{{$parentInfo.dialog_InvoiceDetail.invoiceDetail_val.hasPay}}　</span>元<br>
                            </p>
                            <p>
                                服务费所含相关内容：<br>
                                A.在线教育课程（vip服务）： 应试君课程<br>
                                B.线下咨询及试听课程
                            </p>
                            <div class="table-responsive" style="clear: both;">
                                <table class="table table-bordered">
                                    <thead>
                                    <tr>
                                        <th>学期</th>
                                        <th>课程</th>
                                        <th>老师</th>
                                        <th>时间</th>
                                        <th>校区</th>
                                        <th>班型</th>
                                        <th>课时</th>
                                        <th>课时单价</th>
                                        <th>折扣</th>
                                        <th>总额</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    <tr v-for="item in $parentInfo.dialog_InvoiceDetail.invoiceDetail_val.invoiceItems">
                                        <td>{{item.semester_name}}</td>
                                        <td>{{item.class_name}}</td>
                                        <td>{{item.teacher_name[0]}}老师</td>
                                        <td>{{item.start_time}}</td>
                                        <td>{{item.section_name}}</td>
                                        <td>{{item.class_type_name}}</td>
                                        <td>{{item.period}}</td>
                                        <td>{{item.original_unit_period_price}}</td>
                                        <td>{{item.discount}}</td>
                                        <td>{{item.sum_price}}</td>
                                    </tr>
                                    </tbody>
                                </table>
                            </div>

                            <p>2.支付情况<br>
                                A.实收: ￥ {{$parentInfo.dialog_InvoiceDetail.invoiceDetail_val.hasPay}}<br>
                                B.支付方式 </p>
                            <div class="table-responsive" style="clear: both;">
                                <table class="table table-bordered">
                                    <thead>
                                    <tr>
                                        <th>账户余额</th>
                                        <th>现金</th>
                                        <th>泰隆银行支付宝</th>
                                        <th>泰隆银行微信</th>
                                        <th>银行卡</th>
                                        <th v-if="$parentInfo.dialog_InvoiceDetail.invoiceDetail_val.periodLklZfb>0">拉卡拉（支付宝）</th>
                                        <th v-if="$parentInfo.dialog_InvoiceDetail.invoiceDetail_val.periodLklWetChat>0">拉卡拉（微信）</th>
                                        <th v-if="$parentInfo.dialog_InvoiceDetail.invoiceDetail_val.periodLklBank>0">拉卡拉（银行卡）</th>
                                        <th>优惠</th>
                                        <th v-if="$parentInfo.dialog_InvoiceDetail.invoiceDetail_val.headTeacherLimit>0">班主任优惠</th>
                                        <th v-if="$parentInfo.dialog_InvoiceDetail.invoiceDetail_val.periodUse>0">课时抵消</th>
                                        <th v-if="$parentInfo.dialog_InvoiceDetail.invoiceDetail_val.coupon>0">优惠券</th>
                                        <th v-if="$parentInfo.dialog_InvoiceDetail.invoiceDetail_val.classHour>0">课次金额</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    <tr>
                                        <td>{{$parentInfo.dialog_InvoiceDetail.invoiceDetail_val.hasMoney|currency('￥')}}</td>
                                        <td>{{$parentInfo.dialog_InvoiceDetail.invoiceDetail_val.cash|currency('￥')}}</td>
                                        <td>{{$parentInfo.dialog_InvoiceDetail.invoiceDetail_val.zfb|currency('￥')}}</td>
                                        <td>{{$parentInfo.dialog_InvoiceDetail.invoiceDetail_val.wetChat|currency('￥')}}</td>
                                        <td>{{$parentInfo.dialog_InvoiceDetail.invoiceDetail_val.bank|currency('￥')}}</td>
                                        <td v-if="$parentInfo.dialog_InvoiceDetail.invoiceDetail_val.periodLklZfb>0">
                                            {{$parentInfo.dialog_InvoiceDetail.invoiceDetail_val.periodLklZfb|currency('￥')}}
                                        </td>
                                        <td v-if="$parentInfo.dialog_InvoiceDetail.invoiceDetail_val.periodLklWetChat>0">
                                            {{$parentInfo.dialog_InvoiceDetail.invoiceDetail_val.periodLklWetChat|currency('￥')}}
                                        </td>
                                        <td v-if="$parentInfo.dialog_InvoiceDetail.invoiceDetail_val.periodLklBank>0">
                                            {{$parentInfo.dialog_InvoiceDetail.invoiceDetail_val.periodLklBank|currency('￥')}}
                                        </td>
                                        <td>{{$parentInfo.dialog_InvoiceDetail.invoiceDetail_val.discount|currency('￥')}}</td>
                                        <td v-if="$parentInfo.dialog_InvoiceDetail.invoiceDetail_val.headTeacherLimit>0">
                                            {{$parentInfo.dialog_InvoiceDetail.invoiceDetail_val.headTeacherLimit|currency('￥')}}
                                        </td>
                                        <td v-if="$parentInfo.dialog_InvoiceDetail.invoiceDetail_val.periodUse>0">
                                            {{$parentInfo.dialog_InvoiceDetail.invoiceDetail_val.periodUse|currency('￥')}}
                                        </td>
                                        <td v-if="$parentInfo.dialog_InvoiceDetail.invoiceDetail_val.coupon>0">
                                            {{$parentInfo.dialog_InvoiceDetail.invoiceDetail_val.coupon|currency('￥')}}
                                        </td>
                                        <td v-if="$parentInfo.dialog_InvoiceDetail.invoiceDetail_val.classHour>0">
                                            {{$parentInfo.dialog_InvoiceDetail.invoiceDetail_val.classHour|currency('￥')}}
                                        </td>
                                    </tr>
                                    </tbody>
                                </table>
                            </div>

                            <p>
                                日期：自 {{$parentInfo.dialog_InvoiceDetail.invoiceDetail_val.start_date}}至 全部课程结束
                            </p>

                        </div>
                        <div >
                            <h3>第二条 甲方责任和义务</h3>
                            <p> 1.双方签订本协议后，甲方即为乙方建立文本档案。<br>
                                2.甲方提供一套科学有效的测试题，对乙方进行文化课测试、学习动机测试、学习目标测试、学习兴趣测试、学习习惯测试、考试心态测试等；乙方应如实作答。甲方委派教育咨询师与乙方及乙方监护人沟通，全方面了解乙方学习情况、学校表现、教育历史、过往辅导经历及亲子关系等真实情况，并作详细记录，存入乙方档案。如因乙方提供虚假信息造成甲方咨询判断误差所产生的一切后果由乙方自负。<br>
                                3.甲方组织相关团队对乙方的测试结果和咨询情况进行分析研究。<br>
                                4.甲方每周为乙方提供课外辅导。根据乙方的学习情况，如认为需要增加课时的，可续签协议，费用由乙方承担。为了使乙方的学习卓有成效，甲方根据乙方所使用教材的版本，专门为其配备相应的辅导资料，便于授课教师进行认真备课和针对性的辅导。<br>
                                5.甲方为乙方制订的个性化辅导教案。<br>
                                6.甲方须综合乙方以上所存在的问题和实际情况，适时优化调整授课计划、师资安排和辅导内容。<br>
                                7.甲方最大程度保证授课教师的稳定性，为保证授课计划顺利完成，有权更换授课教师并通知乙方。<br>
                                8.为了提高服务质量和辅导效率，甲方给乙方提供教育资讯网络服务（见公众号与app）
                            </p>
                        </div>
                        <div >
                            <h3>第三条 乙方（乙方监护人）责任和义务</h3>
                            <p> 1.乙方及乙方监护人应到甲方规定地点报名、进行咨询和测试。<br>
                                2.咨询时，乙方及其监护人须提供甲方所需要的一切真实建档信息，以供甲方确定对乙方的辅导方案和授课计划。<br>
                                3.乙方及其监护人应从以下几个方面考察授课教师：是否准时到达，着装是否整洁、普通话是否标准、是否具有亲和力、思路是否清晰、辅导方式是否能接受、解答问题是否熟练综合素质如何等方面。<br>
                                4.乙方需接受甲方安排的学习内容和进度，如需变换须及时通知甲方，甲方认同后方可进行。<br>
                                5.乙方监护人须及时反映乙方在学习过程中出现的新问题，以利于甲方进行个性化辅导。<br>
                                6.在教师授课后，乙方监护人须定期填写授课质量调查表，交授课教师带回甲方。<br>
                                7.乙方需每月写一份个人月总结，总结上个月的学习情况和制订下个月的学习计划，提供给甲方。<br>
                                8.乙方向甲方按照约定交清费用。
                            </p>

                        </div>
                        <div >
                            <h3>第四条 违约责任</h3>
                            <p>1.学生档案作为本协议的一个重要组成部分，由甲方保管，直到双方协议终止。<br>
                                <b>2.在协议执行期间，乙方如对甲方服务不满或有其他原因等情况下，可在协议签署后任意自然日申请解除协议，甲方将扣除乙方部分教材费、及按照实际服务时间比例的乙方服务费、教师授课费，将剩余部分全部退还乙方（折扣均摊、剩余费用扣除现金折扣与送课金额），不收取乙方违约金。</b><br>
                                3.本协议签署后，乙方未按规定日期交清费用的，甲方有权无条件解除协议。<br>
                                4.若由于乙方提供不真实资料签订本协议的，甲方可无条件解除协议，甲方不承担任何违约责任，并有权要求乙方赔偿损失。<br>
                                5.如因自然灾害等不可抗力或政府政策变化等外部因素导致本协议无法继续履行，双方均不承担责任。</p>


                        </div>
                        <div >
                            <h3>第五条 附则</h3>
                            <p>1.本协议一式两份，双方各执一份，自签订之日起生效。协议结束后，双方责任和义务即自动终止。<br>
                                2.对本协议的未尽事项，经双方协商，在此备注：退费相关事项：a.因学生个人社会活动导致的缺席，相关费用不予退还；b.因病假导致的缺席，相关费用以实际费用结算（以挂号单及病历卡或医院提供的病假单为准）；c.因学生社会实践或重大赛事（升学相关）导致的缺席，相关费用以实际费用结算（以活动通知单或为赛事准考证为准）；d.因学校集体活动导致的缺席，相关费用予以全额退还。具体处理方式详见《墨帝教育课程缺席处理办法》。<br>
                                3.寒暑假最后一期统一考试及讲评试卷，如果学生不出席，一律不退费。<br>
                                4. 如遇换课、退课等情况，本协议可重新签订，协议双方权利义务以最新签订的协议为准，签订时间更早的协议失效。
                            </p>

                        </div>


                        <div style="float: left;width: 60%">
                            <p>甲方：上海墨帝教育科技服务有限公司</p>
                            <p>甲方代表签字：</p>
                        </div>
                        <div style="float: left;">
                            <p>乙方： {{$parentInfo.dialog_InvoiceDetail.invoiceDetail_val.student_name}}</p>
                            <p>乙方监护人签字：</p>
                            <p>本协议于{{$parentInfo.dialog_InvoiceDetail.invoiceDetail_val.created_at}}在上海签订</p>
                        </div>

                    </div>
                </div>
                <!--新合同-->
                <div v-else>
                    <!--<div class="noprint">-->
                    <!--</div>-->
                    <div id="printArea"
                         class="printableArea"
                         v-if="$parentInfo.dialog_InvoiceDetail.showOn"
                         :class="{'ph':!$parentInfo.dialog_InvoiceDetail.printOn,'show':$parentInfo.dialog_InvoiceDetail.printOn}"
                         style=";position: relative;">
                        <div v-for="(invoiceItem,index) in $parentInfo.dialog_InvoiceDetail.invoiceDetail_val.invoiceItems" :key="index">
                            <div style="position: relative" class="invoice-body">
                                <div>
                                    <div class='invoiceNumber'>
                                        合同编号：{{$parentInfo.dialog_InvoiceDetail.invoiceDetail_val.id}}-{{invoiceItem.versionNumber}}
                                    </div>
                                    <div >
                                        <h3 class="title">墨帝教育服务协议书</h3>

                                    </div>
                                    <div >

                                        <p><b>甲方（教 育 方）：应试君线上服务平台（上海墨帝教育科技有限服务公司）<br>
                                            甲方地址：上海市青浦区盈港路499弄港隆广场6号 邮政编码：201700<br>
                                            甲方联系方式：13764117924　微信号：modixuelaoshi　公众号：墨帝教育<br>
                                        </b></p>
                                        <p><b>乙方（受教育方）：学生姓名：<span
                                                style="text-decoration: underline">　　{{$parentInfo.dialog_InvoiceDetail.invoiceDetail_val.student_name}}　</span>　　学校：<span
                                                style="text-decoration: underline">　{{$parentInfo.dialog_InvoiceDetail.invoiceDetail_val.student_school}}　
                                    　</span>　　现新年级：<span style="text-decoration: underline">　{{$parentInfo.dialog_InvoiceDetail.invoiceDetail_val.student_grade}}　</span><br>
                                            乙方 监 护 人：<span style="text-decoration: underline">　{{$parentInfo.dialog_InvoiceDetail.invoiceDetail_val.parent_name}}　 {{$parentInfo.dialog_InvoiceDetail.invoiceDetail_val.parent_identity}}　</span>　<br>
                                            乙方 联系方式：<span style="text-decoration: underline">　{{$parentInfo.dialog_InvoiceDetail.invoiceDetail_val.student_phone}}　</span>　　家长联系方式：<span
                                                    style="text-decoration: underline">　{{$parentInfo.dialog_InvoiceDetail.invoiceDetail_val.parent_phone}}　</span>　
                                        </b></p>
                                        <p>
                                            为了使乙方的学习兴趣给予激发，学习习惯给予培养，学习方法给予改进，学习个性给予发扬，学习潜力给予发挥，应试能力给予加强，学习成绩给予提高，甲方和乙方监护人本着诚信、自愿、平等的原则，就委托辅导一事达成如下协议：</p>
                                    </div>
                                    <div >
                                        <h3>第一条 费用及相关内容</h3>

                                        <p>1.乙方向甲方交纳的费用包括：<br>
                                            A.报名建档费、档案管理费、选派教员费、辅导方案制定费和网络服务费。<br>
                                            B.平台服务费用（含辅导费）<span
                                                    style="text-decoration: underline">　{{$parentInfo.dialog_InvoiceDetail.invoiceDetail_val.hasPay*invoiceItem.proportion|currency('￥')}}　</span>元<br>
                                            C.教学设备<br>
                                        </p>
                                        <div class="table-responsive" style="clear: both;" v-if="invoiceItem.invoiceItem_shops.length>0">
                                            <table class="table table-bordered">
                                                <thead>
                                                <tr>
                                                    <th>商品名</th>
                                                    <th>数量</th>
                                                    <th>单价</th>
                                                    <th>折扣</th>
                                                    <th>总额</th>
                                                </tr>
                                                </thead>
                                                <tbody>
                                                <tr v-for="item in invoiceItem.invoiceItem_shops" :key="item.id">
                                                    <td>{{item.shop_name}}</td>
                                                    <td>{{item.amount}}</td>
                                                    <td>{{item.original_unit_price}}</td>
                                                    <td>{{item.discount}}</td>
                                                    <td>{{item.sum_price}}</td>
                                                </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                        <p>
                                            服务费所含相关内容：<br>
                                            A.在线教育课程（vip服务）： 应试君课程<br>
                                            B.线下咨询及试听课程
                                        </p>
                                        <div class="table-responsive" style="clear: both;" v-if="invoiceItem.invoiceItem_sortBy.length>0">
                                            <table class="table table-bordered">
                                                <thead>
                                                <tr>
<!--                                                    <th>学期</th>-->
<!--                                                    <th>课程</th>-->
                                                    <th>老师</th>
<!--                                                    <th>时间</th>-->
                                                    <th>校区</th>
                                                    <th>年级</th>
                                                    <th>学科</th>
                                                    <th>班型</th>
                                                    <th>课时</th>
                                                    <th>课时单价</th>
                                                    <th>折扣</th>
                                                    <th>总额</th>
                                                </tr>
                                                </thead>
                                                <tbody>
                                                <tr v-for="item in invoiceItem.invoiceItem_sortBy">
<!--                                                    <td>{{item.semester_name}}</td>-->
<!--                                                    <td>{{item.class_name}}</td>-->
                                                    <td>{{item.teacher_name[0]}}老师</td>
<!--                                                    <td>{{item.start_time}}</td>-->
                                                    <td>{{item.section_name}}</td>
                                                    <td>{{item.grade_name}}</td>
                                                    <td>{{item.subject_name}}</td>
                                                    <td>{{item.class_type_name}}</td>
                                                    <td>{{item.period}}</td>
                                                    <td>{{item.original_unit_period_price}}</td>
                                                    <td>{{item.discount}}</td>
                                                    <td>{{item.sum_price}}</td>
                                                </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                        <p>
                                            C.课次
                                        </p>
                                        <div class="table-responsive" style="clear: both;" v-if="invoiceItem.invoiceItem_classHours.length>0">
                                            <table class="table table-bordered">
                                                <thead>
                                                <tr>
                                                    <th>课次名</th>
<!--                                                    <th>学期</th>-->
                                                    <th>年级</th>
                                                    <th>时长</th>
                                                    <th>课时</th>
                                                    <th>课时单价</th>
                                                    <th>折扣</th>
                                                    <th>总额</th>
                                                </tr>
                                                </thead>
                                                <tbody>
                                                <tr v-for="item in invoiceItem.invoiceItem_classHours" :key="item.id">
                                                    <td>{{item.classHour_name}}</td>
<!--                                                    <td>{{item.semester_name}}</td>-->
                                                    <td >{{item.grade_name}}</td>
                                                    <td>{{item.time}}</td>
                                                    <td>{{item.period}}</td>
                                                    <td>{{item.unit_period_price}}</td>
                                                    <td>{{item.discount}}</td>
                                                    <td>{{item.sum_price}}</td>
                                                </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                        <p>2.支付情况<br>
                                            A.实收:
                                            {{$parentInfo.dialog_InvoiceDetail.invoiceDetail_val.hasPay*invoiceItem.proportion
                                            |currency('￥')}}<br>
                                            B.支付方式 </p>
                                        <div class="table-responsive" style="clear: both;">
                                            <table class="table table-bordered">
                                                <thead>
                                                <tr>
                                                    <th>账户余额</th>
                                                    <th>现金</th>
                                                    <th>泰隆银行支付宝</th>
                                                    <th>泰隆银行微信</th>
                                                    <th>银行卡</th>
                                                    <th v-if="$parentInfo.dialog_InvoiceDetail.invoiceDetail_val.periodLklZfb>0">拉卡拉（支付宝）</th>
                                                    <th v-if="$parentInfo.dialog_InvoiceDetail.invoiceDetail_val.periodLklWetChat>0">拉卡拉（微信）</th>
                                                    <th v-if="$parentInfo.dialog_InvoiceDetail.invoiceDetail_val.periodLklBank>0">拉卡拉（银行卡）</th>
                                                    <th>优惠</th>
                                                    <th v-if="$parentInfo.dialog_InvoiceDetail.invoiceDetail_val.headTeacherLimit>0">班主任优惠</th>
                                                    <th v-if="$parentInfo.dialog_InvoiceDetail.invoiceDetail_val.periodUse>0">课时抵消</th>
                                                    <th v-if="$parentInfo.dialog_InvoiceDetail.invoiceDetail_val.coupon>0">优惠券</th>
                                                    <th v-if="$parentInfo.dialog_InvoiceDetail.invoiceDetail_val.classHour>0">课次数</th>
                                                    <th v-if="$parentInfo.dialog_InvoiceDetail.invoiceDetail_val.deposit>0">押金</th>
                                                    <th v-if="$parentInfo.dialog_InvoiceDetail.invoiceDetail_val.earnest>0">定金</th>
                                                </tr>
                                                </thead>
                                                <tbody>
                                                <tr>
                                                    <td>
                                                        {{$parentInfo.dialog_InvoiceDetail.invoiceDetail_val.hasMoney*invoiceItem.proportion|currency('￥')}}
                                                    </td>
                                                    <td>
                                                        {{$parentInfo.dialog_InvoiceDetail.invoiceDetail_val.cash*invoiceItem.proportion|currency('￥')}}
                                                    </td>
                                                    <td>
                                                        {{$parentInfo.dialog_InvoiceDetail.invoiceDetail_val.zfb*invoiceItem.proportion|currency('￥')}}
                                                    </td>
                                                    <td>
                                                        {{$parentInfo.dialog_InvoiceDetail.invoiceDetail_val.wetChat*invoiceItem.proportion|currency('￥')}}
                                                    </td>
                                                    <td>
                                                        {{$parentInfo.dialog_InvoiceDetail.invoiceDetail_val.bank*invoiceItem.proportion|currency('￥')}}
                                                    </td>
                                                    <td v-if="$parentInfo.dialog_InvoiceDetail.invoiceDetail_val.periodLklZfb>0">
                                                        {{$parentInfo.dialog_InvoiceDetail.invoiceDetail_val.periodLklZfb*invoiceItem.proportion|currency('￥')}}
                                                    </td>
                                                    <td v-if="$parentInfo.dialog_InvoiceDetail.invoiceDetail_val.periodLklWetChat>0">
                                                        {{$parentInfo.dialog_InvoiceDetail.invoiceDetail_val.periodLklWetChat*invoiceItem.proportion|currency('￥')}}
                                                    </td>
                                                    <td v-if="$parentInfo.dialog_InvoiceDetail.invoiceDetail_val.periodLklBank>0">
                                                        {{$parentInfo.dialog_InvoiceDetail.invoiceDetail_val.periodLklBank*invoiceItem.proportion|currency('￥')}}
                                                    </td>
                                                    <td>
                                                        {{$parentInfo.dialog_InvoiceDetail.invoiceDetail_val.discount*invoiceItem.proportion|currency('￥')}}
                                                    </td>
                                                    <td v-if="$parentInfo.dialog_InvoiceDetail.invoiceDetail_val.headTeacherLimit>0">
                                                        {{$parentInfo.dialog_InvoiceDetail.invoiceDetail_val.headTeacherLimit*invoiceItem.proportion|currency('￥')}}
                                                    </td>
                                                    <td v-if="$parentInfo.dialog_InvoiceDetail.invoiceDetail_val.periodUse>0">
                                                        {{$parentInfo.dialog_InvoiceDetail.invoiceDetail_val.periodUse*invoiceItem.proportion|currency('￥')}}
                                                    </td>
                                                    <td v-if="$parentInfo.dialog_InvoiceDetail.invoiceDetail_val.coupon>0">
                                                        {{$parentInfo.dialog_InvoiceDetail.invoiceDetail_val.coupon*invoiceItem.proportion|currency('￥')}}
                                                    </td>
                                                    <td v-if="$parentInfo.dialog_InvoiceDetail.invoiceDetail_val.classHour>0">
                                                        {{($parentInfo.dialog_InvoiceDetail.invoiceDetail_val.classHour*invoiceItem.proportion).toFixed(2)}}
                                                    </td>
                                                    <td v-if="$parentInfo.dialog_InvoiceDetail.invoiceDetail_val.deposit>0">
                                                        {{($parentInfo.dialog_InvoiceDetail.invoiceDetail_val.deposit*invoiceItem.proportion).toFixed(2)}}
                                                    </td>
                                                    <td v-if="$parentInfo.dialog_InvoiceDetail.invoiceDetail_val.earnest>0">
                                                        {{($parentInfo.dialog_InvoiceDetail.invoiceDetail_val.earnest*invoiceItem.proportion).toFixed(2)}}
                                                    </td>
                                                </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                        <p>
                                            优惠：{{$parentInfo.dialog_InvoiceDetail.invoiceDetail_val.invoice_discount}}
                                        </p>
                                        <p>
                                            日期：自 {{$parentInfo.dialog_InvoiceDetail.invoiceDetail_val.start_date}}至 全部课程结束
                                        </p>

                                    </div>
                                    <div >
                                        <h3>第二条 甲方责任和义务</h3>
                                        <p> 1.双方签订本协议后，甲方即为乙方建立文本档案。<br>
                                            2.甲方提供一套科学有效的测试题，对乙方进行文化课测试、学习动机测试、学习目标测试、学习兴趣测试、学习习惯测试、考试心态测试等；乙方应如实作答。甲方委派教育咨询师与乙方及乙方监护人沟通，全方面了解乙方学习情况、学校表现、教育历史、过往辅导经历及亲子关系等真实情况，并作详细记录，存入乙方档案。如因乙方提供虚假信息造成甲方咨询判断误差所产生的一切后果由乙方自负。<br>
                                            3.甲方组织相关团队对乙方的测试结果和咨询情况进行分析研究。<br>
                                            4.甲方每周为乙方提供课外辅导。根据乙方的学习情况，如认为需要增加课时的，可续签协议，费用由乙方承担。为了使乙方的学习卓有成效，甲方根据乙方所使用教材的版本，专门为其配备相应的辅导资料，便于授课教师进行认真备课和针对性的辅导。<br>
                                            5.甲方为乙方制订的个性化辅导教案。<br>
                                            6.甲方须综合乙方以上所存在的问题和实际情况，适时优化调整授课计划、师资安排和辅导内容。<br>
                                            7.甲方最大程度保证授课教师的稳定性，为保证授课计划顺利完成，有权更换授课教师并通知乙方。<br>
                                            8.为了提高服务质量和辅导效率，甲方给乙方提供教育资讯网络服务（见公众号与app）
                                        </p>
                                    </div>
                                    <div >
                                        <h3>第三条 乙方（乙方监护人）责任和义务</h3>
                                        <p> 1.乙方及乙方监护人应到甲方规定地点报名、进行咨询和测试。<br>
                                            2.咨询时，乙方及其监护人须提供甲方所需要的一切真实建档信息，以供甲方确定对乙方的辅导方案和授课计划。<br>
                                            3.乙方及其监护人应从以下几个方面考察授课教师：是否准时到达，着装是否整洁、普通话是否标准、是否具有亲和力、思路是否清晰、辅导方式是否能接受、解答问题是否熟练综合素质如何等方面。<br>
                                            4.乙方需接受甲方安排的学习内容和进度，如需变换须及时通知甲方，甲方认同后方可进行。<br>
                                            5.乙方监护人须及时反映乙方在学习过程中出现的新问题，以利于甲方进行个性化辅导。<br>
                                            6.在教师授课后，乙方监护人须定期填写授课质量调查表，交授课教师带回甲方。<br>
                                            7.乙方需每月写一份个人月总结，总结上个月的学习情况和制订下个月的学习计划，提供给甲方。<br>
                                            8.乙方向甲方按照约定交清费用。
                                        </p>

                                    </div>
                                    <div >
                                        <h3>第四条 违约责任</h3>
                                        <p>1.学生档案作为本协议的一个重要组成部分，由甲方保管，直到双方协议终止。<br>
                                            <b>2.在协议执行期间，乙方如对甲方服务不满或有其他原因等情况下，可在协议签署后任意自然日申请解除协议，甲方将扣除乙方教学设备费、部分教材费、及按照实际服务时间比例的乙方服务费、教师授课费，将剩余部分全部退还乙方（折扣均摊、剩余费用扣除现金折扣与送课金额），不收取乙方违约金。</b><br>
                                            3.线上课相关优惠仅可用于线上课程，若终止线上课程，以4.2解除协议方式处理且相关优惠不得转用于线下课程。<br>
                                            4.本协议签署后，乙方未按规定日期交清费用的，甲方有权无条件解除协议。<br>
                                            5.若由于乙方提供不真实资料签订本协议的，甲方可无条件解除协议，甲方不承担任何违约责任，并有权要求乙方赔偿损失。<br>
                                            6.如因自然灾害等不可抗力或政府政策变化等外部因素导致本协议无法继续履行，双方均不承担责任。</p>


                                    </div>
                                    <div >
                                        <h3>第五条 附则</h3>
                                        <p>1.本协议一式两份，双方各执一份，自签订之日起生效。协议结束后，双方责任和义务即自动终止。<br>
                                            2.对本协议的未尽事项，经双方协商，在此备注：退费相关事项：a.因学生个人社会活动导致的缺席，相关费用不予退还；b.因病假导致的缺席，相关费用以实际费用结算（以挂号单及病历卡或医院提供的病假单为准）；c.因学生社会实践或重大赛事（升学相关）导致的缺席，相关费用以实际费用结算（以活动通知单或为赛事准考证为准）；d.因学校集体活动导致的缺席，相关费用予以全额退还。具体处理方式详见《墨帝教育课程缺席处理办法》。<br>
                                            3.寒暑假最后一期统一考试及讲评试卷，如果学生不出席，一律不退费。<br>
                                            4. 如遇换课、退课等情况，本协议可重新签订，协议双方权利义务以最新签订的协议为准，签订时间更早的协议失效。
                                        </p>

                                    </div>

                                    <div style="float: left;width: 60%">
                                        <p>甲方：上海墨帝教育科技服务有限公司</p>
                                        <p>甲方代表签字：</p>
                                    </div>
                                    <div style="float: left;">
                                        <p>乙方： {{$parentInfo.dialog_InvoiceDetail.invoiceDetail_val.student_name}}</p>
                                        <p>乙方监护人签字：</p>
                                        <p>本协议于{{$parentInfo.dialog_InvoiceDetail.invoiceDetail_val.created_at}}在上海签订</p>
                                    </div>

                                    <div style="clear: both"></div>
                                </div>
                            </div>
                            <div class="page-break" v-if="index==0"></div>
                        </div>
                    </div>

                </div>
            </div>
        </vue-scroll>

    </div>
</template>
<style lang="scss">
    #msg{
        width:100px !important;
        height:100px !important;
    }
    .show {
        overflow: auto;
    }

    .ph {
        height: 100% !important;
    }

    .printableArea {
        padding: 10px 20px;
        color: #000 !important;
        font-weight: 500;
    }

    .printableArea .invoiceNumber{
        position:absolute;right:30px;font-size:10px;color:rgba(120, 130, 140, 0.74);
    }
    .printableArea .title{
        margin-top: 0;line-height: 30px;font-size: 18px;font-weight: 500;text-align: center;
    }
    .printableArea h3 {
        line-height: 30px;
        font-size: 15px;
        font-weight: 500;
    }

    .printableArea p {
        font-size: 12px;
        padding-left: 15px;
        padding-right: 15px;
    }

    .printableArea table {
        font-size: 12px;
        border-color: #000;
    }

    .printableArea .table-bordered > tbody > tr > td, .printableArea .table-bordered > tbody > tr > th,
    .printableArea .table-bordered > tfoot > tr > td, .printableArea .table-bordered > tfoot > tr > th,
    .printableArea .table-bordered > thead > tr > td, .printableArea .table-bordered > thead > tr > th {
        border: 1px solid #000 !important;
        color: #000;
        font-size: 12px;
        font-weight: 500 !important;
    }

    .printableArea .table > tbody > tr > td, .printableArea .table > tbody > tr > th, .printableArea .table > tfoot > tr > td, .printableArea .table > tfoot > tr > th, .printableArea .table > thead > tr > td, .printableArea .table > thead > tr > th {
        padding: 7px 9px;
    }

    .printableArea .table-responsive {
        padding: 0 15px;
    }

    .printableArea .page-break{
        page-break-before: always  !important;
    }

    @media print{
        #print {
            .printableArea {
                padding: 0 !important;
                color: #000 !important;
                font-weight: 500;

            }

            .invoice-body{
                page-break-before:always;
            }

            .printableArea .title{
                margin-top: 0;
                line-height: 40px;
                font-size: 25px;
                font-weight: 500;
                text-align: center;

            }
            .printableArea .invoiceNumber{
                position:absolute;right:30px;font-size:15px;color:rgba(120, 130, 140, 0.74);
            }

            .printableArea h3 {
                line-height: 30px;
                font-size: 21px;
                font-weight: 500;
            }


            .printableArea p {
                font-size: 18px;
                padding-left: 15px;
                padding-right: 15px;
            }

            .printableArea table {
                font-size: 18px;
                border-color: #000;
            }

            .printableArea .table-bordered > tbody > tr > td, .printableArea .table-bordered > tbody > tr > th,
            .printableArea .table-bordered > tfoot > tr > td, .printableArea .table-bordered > tfoot > tr > th,
            .printableArea .table-bordered > thead > tr > td, .printableArea .table-bordered > thead > tr > th {
                border: 1px solid #000 !important;
                color: #000;
                font-size: 18px;
                font-weight: 500 !important;
            }

            .printableArea .table > tbody > tr > td, .printableArea .table > tbody > tr > th, .printableArea .table > tfoot > tr > td, .printableArea .table > tfoot > tr > th, .printableArea .table > thead > tr > td, .printableArea .table > thead > tr > th {
                padding: 7px 9px;
            }

            .printableArea .table-responsive {
                padding: 0 15px;
            }

            .printableArea .page-break{
                page-break-before: always  !important;
            }
        }
    }
</style>
<script>
    import QRCode from 'qrcode'
    export default {
        name: 'Dialog_InvoiceDetail',
        data() {
            return {
                QRCodeMsg:'234',
            };
        },
        computed: {
            clientHeight() {
                return this.$store.state.config.clientHeight
            },
        },
        created() {
            this.$parentInfo = this.$root.$children[0].$refs['dashboard'].$refs[this.$route.path];
            this.handleInvoiceDetail()
            this.QRCodeMsg='http://server.modijiaoyu.com/invoicePhoto?invoice_id='+this.$store.state.modal.data.invoice_id
        },
        mounted(){
            var msg= document.getElementById('msg')
            // 将获取到的数据（val）画到msg（canvas）上
            QRCode.toCanvas(msg, this.QRCodeMsg, function (error) {
            })
        },
        methods: {
            handleInvoiceDetail() {
                this.$wApi.send(this.$parentInfo.path, 'invoiceDetail', {
                    'invoice_id': this.$store.state.modal.data.invoice_id,
                });
            },
            modelClose() {
                ipc.send('invoiceDetailClose');
            },

        }
    };
</script>
